import React from 'react';

function Loader(props) {
	return <div>Loading...</div>;
}

export default Loader;
